import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
//Redux
import { useDispatch } from "react-redux";
import { setUserLogged } from "../../reducers/userConfigSlice";
//Components
import { Input } from "../../components/inputs/type1";
import { GoMail } from "react-icons/go";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { RiErrorWarningFill } from "react-icons/ri";
//Assets
//Api
import { logIn, validateLogIn } from "../../api/login";
import { decodeToken } from "../../api/utils";

export const FormLogin = ({ callback }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loginFailed, setLoginFailed] = useState(false);
  const [require2FA, setRequire2FA] = useState(false);

  const [busy,setBusy]=useState(false);
  const [requestError,setRequestError]=useState("");
  const pending=useRef(false);
  const run=async(action)=>{if(pending.current)return;pending.current=true;setBusy(true);setRequestError("");try{await action();}catch{setRequestError("No se pudo comprobar el acceso. Inténtalo de nuevo.");}finally{pending.current=false;setBusy(false);}};
  const handleLogin=()=>run(performLogin);
  const handle2FA=()=>run(perform2FA);
  const performLogin = async () => {
    const email = document.getElementById("emailInput").value;
    const password = document.getElementById("passwordInput").value;
    const data = {
      email: email,
      password: password,
    };
    const response = await logIn(data);
    // Previous behaviour: backend may return `false` to indicate 2FA is required.
    if (response === undefined) {
      setLoginFailed(false);
      setRequestError("No se pudo iniciar sesión. Comprueba los datos y vuelve a intentarlo.");
      return;
    }

    if (response === false) {
      setLoginFailed(false);
      setRequire2FA(true);
      return;
    }

    // If backend returns a token/payload directly (no 2FA), allow login.
    if (response && typeof response === "object") {
      dispatch(
        setUserLogged({
          logged: true,
          token: response,
          rol: "admin",
          email: response.email,
          fullname: response.fullname,
          superAdminId: response.superAdminId,
        })
      );
      navigate("/admin");
      return;
    }

    setLoginFailed(true);
  };

  const perform2FA = async () => {
    const code = document.getElementById("2faInput").value;
    const response = await validateLogIn({
      code: code,
    });
    if (response === undefined) {
      setRequestError("No se pudo comprobar el código. Inténtalo de nuevo.");
      return;
    }
    if (response !== undefined && response.data) {
      const responseDecoded = decodeToken(response.data);
      if (responseDecoded) {
        dispatch(
          setUserLogged({
            logged: true,
            token: responseDecoded,
            rol: "admin",
            email: responseDecoded.email,
            fullname: responseDecoded.fullname,
            superAdminId: responseDecoded.superAdminId,
          })
        );
        navigate("/admin");
      } else {
        setLoginFailed(true);
      }
    } else {
      setLoginFailed(true);
    }
  };

  const LoginComponent = () => {
    return (
      <>
        <p className="labelLogin">Email</p>
        <Input
          key="emailInput" id={"emailInput"} ariaLabel="Email"
          type={"text"}
          placeholder=""
          disabled={busy}
          onKeyPress={e=>{if(e.key === "Enter"){e.preventDefault();require2FA?handle2FA():handleLogin();}}}
          icon={<GoMail />}
          classname={loginFailed ? "errorValueInput" : ""}
        />
        <p className="labelLogin">Contraseña</p>
        <Input
          key="passwordInput" id={"passwordInput"} ariaLabel="Contraseña"
          type={"password"}
          placeholder=""
          disabled={busy}
          onKeyPress={e=>{if(e.key === "Enter"){e.preventDefault();require2FA?handle2FA():handleLogin();}}}
          icon={<AiOutlineEyeInvisible />}
          iconType={"tooglePasswordVisibility"}
          classname={loginFailed ? "errorValueInput" : ""}
        />
        {loginFailed ? (
          <div className="errorValue errorMessage">
            <RiErrorWarningFill /> {"El usuario o la contraseña no son correctos"}
          </div>
        ) : (
          ""
        )}

        <div className="sa-login-help"><button type="button" disabled={busy} className="forgetPass" onClick={callback}>He olvidado mi contraseña</button></div>
        <button type="button" disabled={busy} className="button-1" onClick={handleLogin}>
          {busy ? "Comprobando…" : "Iniciar sesión"}
        </button>
      </>
    );
  };

  const Login2FA = () => {
    return (
      <>
        <p className="sa-code-help">Revisa el correo de la cuenta con la que has iniciado sesión e introduce el código recibido.</p><p className="labelLogin">Código de verificación</p>
        <Input
          key="2faInput" id={"2faInput"} ariaLabel="Código de verificación"
          type={"text"}
          placeholder=""
          disabled={busy}
          onKeyPress={e=>{if(e.key === "Enter"){e.preventDefault();require2FA?handle2FA():handleLogin();}}}
          icon={null}
          classname={loginFailed ? "errorValueInput" : ""}
        />
        {loginFailed ? (
          <div className="errorValue errorMessage">
            <RiErrorWarningFill /> {"El código es incorrecto"}
          </div>
        ) : (
          ""
        )}

        <div className="flex infoLoginPass mt-1">
          <button
            type="button"
            disabled={busy}
            className="forgetPass w-100"
            onClick={() => setRequire2FA(false)}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            Volver a pedir el código
          </button>
        </div>

        <button type="button" disabled={busy} className="button-1" onClick={handle2FA}>
          {busy ? "Comprobando…" : "Acceder"}
        </button>
      </>
    );
  };

  return <form onSubmit={e=>{e.preventDefault();require2FA?handle2FA():handleLogin();}} aria-busy={busy}>{requestError && <p role="alert">{requestError}</p>}{!require2FA ? LoginComponent() : Login2FA()}</form>;
};
